import { useState } from 'react'
import { Campo } from '@/components/ui/Campo'
import { SelectorFecha } from '@/components/ui/SelectorFecha'
import { useAvisar } from '@/components/ui/avisador-contexto'
import { ModalMarco, mensajeDeError } from '@/features/admin/ModalMarco'
import { formatearFechaLarga } from '@/features/grilla/formato'
import type { PublicacionResumen } from '@/lib/schemas/publicaciones'
import { useReprogramar } from './api'

interface ModalReprogramarProps {
  abierto: boolean
  alCerrar: () => void
  publicacion: PublicacionResumen
}

/**
 * §7.2.5 — reprogramar no cambia estado ni versión y deja actividad visible
 * al cliente. El aviso ofrece Deshacer durante diez segundos.
 */
export function ModalReprogramar({
  abierto,
  alCerrar,
  publicacion,
}: ModalReprogramarProps) {
  const reprogramar = useReprogramar()
  const avisar = useAvisar()
  const [fecha, setFecha] = useState(publicacion.fechaPautada)
  const [error, setError] = useState<string | null>(null)
  const [ocupado, setOcupado] = useState(false)

  const original = publicacion.fechaPautada

  return (
    <ModalMarco
      abierto={abierto}
      alCerrar={alCerrar}
      titulo="Reprogramar"
      // Se mueve el día: la hora, si tiene, se conserva (DEC-20).
      descripcion={`Hoy está pautada para el ${formatearFechaLarga(original, publicacion.horaPautada)}.${publicacion.horaPautada ? ' La hora se mantiene.' : ''}`}
      guardar="Reprogramar"
      ocupado={ocupado}
      error={error}
      alCambiar={() => {
        setError(null)
      }}
      alEnviar={() => {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
          setError('La fecha es obligatoria.')
          return
        }
        setOcupado(true)
        reprogramar
          .mutateAsync({ id: publicacion.id, fechaPautada: fecha })
          .then(() => {
            avisar(`Reprogramada al ${formatearFechaLarga(fecha)}`, {
              accion: {
                etiqueta: 'Deshacer',
                alHacer: () => {
                  void reprogramar.mutateAsync({
                    id: publicacion.id,
                    fechaPautada: original,
                  })
                },
              },
            })
            alCerrar()
          })
          .catch((e: unknown) => {
            setError(mensajeDeError(e))
          })
          .finally(() => {
            setOcupado(false)
          })
      }}
    >
      <Campo etiqueta="Nueva fecha">
        {(p) => <SelectorFecha id={p.id} valor={fecha} alCambiar={setFecha} />}
      </Campo>
    </ModalMarco>
  )
}
